angular.module('unica_invitation.invitation_controllers', [])

.controller('InvitationBasicController',
	function(
		$rootScope, $scope,
		InvitationListService
	) {


});